<div class="contact-form">
   <mat-divider></mat-divider>

   <h3 color="primary">Contacts</h3>

   <div class="contacts">
      <div class="contact" *ngFor="let contact of contacts.controls; index as i; odd as odd" [class.shady]="odd" [formGroup]="contact">
         <div class="contact-buttons" *ngIf="i != contacts.controls.length - 1">
            <button mat-stroked-button [matMenuTriggerFor]="pinMenu" *ngIf="contact.value as value">
               <mat-icon class="pin-star" *ngIf="!value.pinned && !value.default">star_border</mat-icon>
               <mat-icon class="pin-star" color="accent" *ngIf="value.pinned && !value.default">star</mat-icon>
               <mat-icon class="pin-star" color="primary" *ngIf="value.default">star</mat-icon>
               &nbsp;&nbsp;
               {{value.default ? 'PRIMARY' : value.pinned ? 'PINNED' : 'UNPINNED'}}
            </button>

            <mat-menu #pinMenu="matMenu" class="pin-menu" yPosition="below" overlapTrigger="false">
               <ng-template matMenuContent>
                  <button mat-menu-item (click)="pin( contact, 'primary' )">
                     <mat-icon class="pin-star" color="primary">star</mat-icon> PRIMARY
                  </button>
                  <button mat-menu-item (click)="pin( contact, 'pin' )">
                     <mat-icon class="pin-star" color="accent">star</mat-icon> PINNED
                  </button>
                  <button mat-menu-item (click)="pin( contact, null );">
                     <mat-icon class="pin-star">star_border</mat-icon> UNPINNED
                  </button>
               </ng-template>
            </mat-menu>

            <button mat-icon-button color="warn" (click)="contacts.removeAt(i)" matTooltip="Delete {{cname.value ? cname.value : 'Contact'}}" matTooltipPosition="left" tabindex="-1" class="common-mlauto">
               <mat-icon>clear</mat-icon>
            </button>
         </div>

         <div class="contact-info">
            <mat-form-field #cname_field>
               <mat-label>Name</mat-label>
               <input matInput #cname formControlName="name" [required]="required?.name" [maxlength]="lengths?.name" [errorStateMatcher]="nameMatcher">
               <mat-error libInputErrors [control]="contact.get('name')"></mat-error>
               <mat-hint align="end" *ngIf="lengths?.name && focused( cname_field ) && cname?.value.length as l">{{l || 0}} / {{lengths?.name}}</mat-hint>
            </mat-form-field>

            <mat-form-field #ctitle_field>
               <mat-label>Title</mat-label>
               <input matInput #ctitle formControlName="title" [required]="required?.title" [maxlength]="lengths?.title">
               <mat-error libInputErrors [control]="contact.get('title')"></mat-error>
               <mat-hint align="end" *ngIf="lengths?.title && focused( ctitle_field ) && ctitle?.value.length as l">{{l || 0}} / {{lengths?.title}}</mat-hint>
            </mat-form-field>

            <mat-form-field #cphone_field>
               <mat-label>Phone</mat-label>
               <input matInput #cphone formControlName="phone" [required]="required?.phone" [maxlength]="lengths?.phone" [errorStateMatcher]="oneOfMatcher">
               <mat-error libInputErrors [control]="contact.get('phone')"></mat-error>
               <mat-hint align="end" *ngIf="lengths?.phone && focused( cphone_field ) && cphone?.value.length as l">{{l || 0}} / {{lengths?.phone}}</mat-hint>
            </mat-form-field>

            <mat-form-field #cemail_field>
               <mat-label>Email</mat-label>
               <input matInput #cemail type="email" formControlName="email" [required]="required?.email" [maxlength]="lengths?.email" [errorStateMatcher]="oneOfMatcher">
               <mat-error libInputErrors [control]="contact.get('email')"></mat-error>
               <mat-hint align="end" *ngIf="lengths?.email && focused( cemail_field ) && cemail?.value.length as l">{{l || 0}} / {{lengths?.email}}</mat-hint>
            </mat-form-field>
         </div>
      </div>
   </div>
</div>
